import {useLocation} from '@s-ui/react-router'
import {useMessagingThirdPartyContext} from '@adv-mt/mt-messaging'

import {useInteractionsConfig} from './config/useInteractionsConfig.js'
import {useMessagingContext} from './useMessagingContext/index.js'

export const useGetIntegrationActions = () => {
  const {state, setInteractionComponent, setInteractionInfo, setChannelsIntegrations} = useMessagingContext()
  const {channelsIntegrations} = state
  const {state: routerState} = useLocation()
  const {getInteractionsConfig} = useInteractionsConfig(routerState)
  const {currentChannels, currentUser} = useMessagingThirdPartyContext()

  const getIntegrationActions = channelId => {
    return channelsIntegrations[channelId] || []
  }

  const setInteractionResponse = (interactionObj, url) => {
    switch (interactionObj.type) {
      case 'component':
        setInteractionComponent({component: interactionObj.callback, show: true})
        break
      case 'function': {
        interactionObj.callback(url)
        break
      }
      case 'trigger': {
        interactionObj.callback()
        break
      }
      default:
        break
    }
  }

  const handleOnDirectCall = (url, params) => {
    const configObj = getInteractionsConfig(url, params)
    setInteractionResponse(configObj, url)
  }

  const getLinkActionUrl = link => {
    return () => {
      setInteractionInfo({params: {}, url: link})
      handleOnDirectCall(link, {})
    }
  }

  const formatActionsByChannel = ({currentChannelId}) => {
    const map = currentChannels?.data?.reduce((acc, item) => {
      const id = item?.data?.id
      const integrations = item?.data?.integrations
      const integrationsValues = Object.values(integrations || {})

      if (id && integrationsValues.length > 0 && typeof integrations === 'object') {
        const allActions = integrationsValues
          .map(integration => integration.actions || [])
          .flat()
          .filter(action => action.userId === currentUser.id)

        const formatted = allActions.map(action => {
          if (currentChannelId === id) setInteractionInfo({params: {}, url: action.href})
          return {
            actionUrl: action.href,
            label: action.label,
            onClick: handleOnDirectCall || (() => {})
          }
        })
        acc[id] = formatted
      }

      return acc
    }, {})
    setChannelsIntegrations(map)
    return map
  }

  return {getIntegrationActions, formatActionsByChannel, getLinkActionUrl, setInteractionResponse}
}
